import {
    GET_LOGIN_STATUS
} from '../middleware/types'

const initialState = {
    SUBMIT_loading: false,
    error: {},
}

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_LOGIN_STATUS:
            return {
                ...state,
                SUBMIT_loading: false,
                loginStatus: action.loginStatus,
            }
        default:
            return state
    }
}